import lodash from 'lodash';
import moment from 'moment';

import { nodeWithArgs } from 'common/util/queryHelper';
import { reportTypes, DATE_FORMAT, TIME_FORMAT } from './constants';
import styles from '../containers/ReportContent.scss';

export const billableHistoryReportColumns = {
    binderTitle: { key: 'binderTitle', label: 'Binder Title', filter: 'Filter name' },
    billableStatus: { key: 'billableStatus', label: 'Billable Status', filter: 'Filter status' },
    createdAt: { key: 'createdAt', label: 'Date Changed', filter: 'Filter date changed' },
    changedByUser: { key: 'changedByUser', label: 'User', filter: 'Filter by user' },
    changeTime: { key: 'changeTime', label: 'Time', filter: 'Filter by time' },
};

const billableHistoryReportColumnValues = lodash.values(billableHistoryReportColumns);

export const billableHistoryReportDefaultColumns = [
    billableHistoryReportColumns.binderTitle.key,
    billableHistoryReportColumns.billableStatus.key,
    billableHistoryReportColumns.createdAt.key,
    billableHistoryReportColumns.changedByUser.key,
    billableHistoryReportColumns.changeTime.key
];
export const billableHistoryReportColumnList = lodash.orderBy(billableHistoryReportColumnValues, ['label'], ['asc']);


export const getBillableHistoryReportNode = (institutionId) => {
    return nodeWithArgs('getBinderBillableHistory', {
        institutionId
    }, [
        'billableStatus',
        'createdAt',
        'changedByUser',
        'binderTitle'
    ]);
};

export const formatMaterialTableBillableHistoryColumns = (customizeColumns) => {
    const valueToBeReturned = [
        {
            title: billableHistoryReportColumns.binderTitle.label,
            field: billableHistoryReportColumns.binderTitle.key,
            filterPlaceholder: billableHistoryReportColumns.binderTitle.filter,
            hidden: !customizeColumns.includes(billableHistoryReportColumns.binderTitle.key),
            render: rowData => <p className={styles.reportTitle}>{rowData[billableHistoryReportColumns.binderTitle.key]}</p>,
        },
        {
            title: billableHistoryReportColumns.billableStatus.label,
            field: billableHistoryReportColumns.billableStatus.key,
            filterPlaceholder: billableHistoryReportColumns.billableStatus.filter,
            hidden: !customizeColumns.includes(billableHistoryReportColumns.billableStatus.key),
        },
        {
            title: billableHistoryReportColumns.changedByUser.label,
            field: billableHistoryReportColumns.changedByUser.key,
            filterPlaceholder: billableHistoryReportColumns.changedByUser.filter,
            hidden: !customizeColumns.includes(billableHistoryReportColumns.changedByUser.key),
        },
        {
            title: billableHistoryReportColumns.createdAt.label,
            field: billableHistoryReportColumns.createdAt.key,
            filterPlaceholder: billableHistoryReportColumns.createdAt.filter,
            hidden: !customizeColumns.includes(billableHistoryReportColumns.createdAt.key),
            render: rowData => {
                return moment(rowData[billableHistoryReportColumns.createdAt.key]).format(DATE_FORMAT);
            },
        },
        {
            title: billableHistoryReportColumns.changeTime.label,
            field: billableHistoryReportColumns.changeTime.key,
            filterPlaceholder: billableHistoryReportColumns.changeTime.filter,
            hidden: !customizeColumns.includes(billableHistoryReportColumns.changeTime.key),
            sorting: false,
            filtering: false,
            render: rowData => {
                return moment(rowData[billableHistoryReportColumns.createdAt.key]).format(TIME_FORMAT);
            },
        },

    ];

    return valueToBeReturned;
};

export const reportAuditHistoryOptionData = {
    name: reportTypes.billableHistory,
    displayName: 'Binder Billable History',
    reportType: reportTypes.billableHistory,
    parameters: [
        {
            id: 'institutionId',
            choice: 'institutionId',
            choiceLabel: 'Get a report on all binders for this Institution',
            isChoiceRequired: true,
            isChoiceHidden: true,
            label: 'Institution Id',
            type: null,
            source: null,
            dataKey: 'institutionId',
            target: 'institutionId',
            submit: true,
        },
        {
            id: 'all',
            choice: 'emails',
            choiceLabel: 'Choose a list of email addresses to restrict results to:',
            isChoiceRequired: true,
            isChoiceHidden: false,
            label: 'Include all user emails',
            type: null,
            source: null,
            target: null,
            submit: false,
        },
        {
            id: 'emails',
            choice: 'emails',
            choiceLabel: 'Choose a list of email addresses to restrict results to:',
            isChoiceRequired: false,
            label: 'Include only these user emails',
            type: 'multiselect',
            source: 'emails',
            dataKey: 'emails',
            target: 'emails',
            submit: true,
        },
    ],
};
